import React from 'react';
import { getConfig } from '../services/configManager';
import { useAppState } from '../hooks/useAppState';

const Footer: React.FC = () => {
  const { state, setStep, setReturnStep } = useAppState();
  const contactUsEnabled = getConfig().FEATURES.ContactUs.Enabled;

  const handleContactUs = () => {
    setReturnStep(state.currentStep);
    setStep('contact-us');
  };

  return (
    <footer className="bg-gray-bg py-8 px-4">
      <div className="flex flex-col items-center gap-8">
        <div className="flex flex-col items-center gap-2">
          {/* <p className="text-black text-small">Powered by</p> */}
          <img 
            src={`${getConfig().ASSETS.BASE_URL}/power-by-logo.png`}
            alt="Power by Tiba"
            className="h-16 w-auto object-contain"
          />
        </div>
        
        <div className="flex flex-col items-center gap-4 text-black text-small w-full">
          <div className="flex justify-between items-center w-full md:gap-12 md:w-auto">
            <a
              href={`${getConfig().ASSETS.BASE_URL}${getConfig().ASSETS.FILES.TERMS_AND_CONDITIONS}`}
              className="underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms & Conditions
            </a>
            {contactUsEnabled && (
              <button
                type="button"
                onClick={handleContactUs}
                className="underline text-small text-black"
              >
                Contact Us
              </button>
            )}
            <a
              href={`${getConfig().ASSETS.BASE_URL}${getConfig().ASSETS.FILES.PRIVACY_POLICY}`}
              className="underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </div>
          {/* <p>© TIBA 2025</p> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer; 